/**
 * Service configuration
 * Automatically switches between real and mock services based on VITE_DEMO_MODE
 */

const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true';

// Brand Health Service V2
import brandHealthServiceV2Real from './brandHealthServiceV2';
import brandHealthServiceV2Mock from './brandHealthServiceV2.mock';

export const brandHealthServiceV2 = isDemoMode
  ? brandHealthServiceV2Mock
  : brandHealthServiceV2Real;

// Chat Service
import chatServiceReal from './chatService';
import chatServiceMock from './chatService.mock';

export const chatService = isDemoMode
  ? chatServiceMock
  : chatServiceReal;

// Re-export types
export type {
  Brand,
  EquityData,
  FunnelData,
  ChannelData,
  PositioningData,
  DigitalMetrics,
  SentimentData,
  LoyaltyData,
  FilterOptions
} from './brandHealthServiceV2';

export type {
  ChatMessage,
  ChatSession,
  ChatSessionDetail
} from './chatService';

// Export demo mode flag for components to use
export { isDemoMode };
